import {useSelector} from 'react-redux';
import {forwardRef} from "react";

import {appSelector} from '../../slices/appSlice';
import {matrixSelector} from '../../slices/matrixSlice';
import AddToCart from './AddToCart';
import Dpo from './Dpo';

const Dispatch = forwardRef(({trackingRef}, ref) => {
  const {dispatchType} = useSelector(appSelector);
  const {
    productName,
    prices,
  } = useSelector(matrixSelector);

  return (
    <>
      <div className="mb-sm tablet:mb-2xl text-sm">
        <div>
          <span className="font-bold">{Drupal.t('Product:', {}, { context: 'Product Name Label in Configurator (above CTA)' })}</span> {productName}
        </div>
        <If condition={prices?.selection_quantity}>
          <div>
            <span className="font-bold">{Drupal.t('Quantity:', {}, { context: 'Quantity Label in Configurator (above CTA)' })}</span>{' '}
            {prices.selection_quantity.toLocaleString()}{' '}
            {prices.selection_quantity === 1
              ? prices.labels.singular_price_label
              : prices.labels.plural_price_label}
          </div>
        </If>
      </div>
      <Choose>
        <When condition={dispatchType === 'cart'}>
          <AddToCart {...{trackingRef}} />
        </When>
        <When condition={dispatchType === 'dpo'}>
          <Dpo ref={ref} {...{trackingRef}} />
        </When>
      </Choose>
    </>
  );
});

export default Dispatch;
